import React from 'react'

export const Disclaimer = () => {
  return (
    <div className='bg--blue x color--white'>
      <div className='container--1000 mxa p2 tc outer'>
        <div>
          <p>This is a demo site built by <a className='cw' href='https://kevingreen.sucks' target='_blank'>Kevin Green</a>. The products you find on this test site are from sites I've worked on. If you're interested in purchasing anything for real I link out to the real sites on the product landing pages!</p>
        </div>
      </div>
    </div>
  )
}